import React from "react";

function GercelSayilarinIslemOzellikleri() {
  return <div>GercelSayilarinIslemOzellikleri</div>;
}

export default GercelSayilarinIslemOzellikleri;
